import { EventBusFactory } from '@utilities/event-bus';
import { ShowToastCommand } from './handlers/onShowToast';
import { ChangeLanguageCommand } from './handlers/onChangeLanguage';

const EventBus = EventBusFactory.resolve('global');

/**
 * ### Application Events Dispatcher
 *
 * ---
 *
 * #### Commands:
 * - **showToast**: Shows a toast in the screen.
 * - **changeLanguage**: Change UI Language.
 * - **changeThemeMode**: Change UI Theme mode.
 *
 * @author <pino0071@gmail.com> Jose Aburto
 */
class AppDispatcher {
  /**
   * Dispatch a command to show a toast in the screen. That
   * message will be translated if that value exist as key in `locales`,
   * otherwise will show exact message.
   */
  public showToast(command: ShowToastCommand): void {
    EventBus.dispatch('show-toast', command);
  }

  /**
   * Dispatch a command to show a toast in the screen. That
   * message will be translated if that value exist as key in `locales`,
   * otherwise will show exact message.
   */
  public changeLanguage(command: ChangeLanguageCommand): void {
    EventBus.dispatch('change-language', command);
  }

  /**
   * Dispatch a command to change UI Theme {light|dark}
   */
  public changeThemeMode(command: { mode: 'light' | 'dark' }): void {
    EventBus.dispatch('change-theme-mode', command.mode);
  }

  public visitPage(command: { path: string }): void {
    EventBus.dispatch('visit-page', command.path);
  }
}

const dispatcher = new AppDispatcher();

if (process.env.NODE_ENV === 'development') {
  window['AppDispatcher'] = dispatcher;
}

export default dispatcher;
